var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_person_light",
    "data-name": "UI icon/person/light",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_132_Stroke_",
    "data-name": "Ellipse 132 (Stroke)",
    d: "M5,10a5,5,0,1,1,5-5A5.006,5.006,0,0,1,5,10ZM5,2A3,3,0,1,0,8,5,3,3,0,0,0,5,2Z",
    transform: "translate(4 0)",
    fill: "#6f767e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_631_Stroke_",
    "data-name": "Vector 631 (Stroke)",
    d: "M6,2A4,4,0,0,0,2,6V7A1,1,0,0,1,0,7V6A6,6,0,0,1,6,0h6a6,6,0,0,1,6,6V7a1,1,0,0,1-2,0V6a4,4,0,0,0-4-4Z",
    transform: "translate(0 12)",
    fill: "#6f767e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.6ede0045335171a2b5becc081938b89e.svg";
export { ForwardRef as ReactComponent };